<template lang="html">
  <div class="main-container">
    <!-- Author: Vaishnavi
      Date: 11/12/2019
      Issue Description: Breadcrumb alignment -->
        <breadcrumb :list="breadcrumbList" />
    <tl-header type="h1">
      <div class="main-header">Salary Components</div>
    </tl-header>
     <div class="filters">
          <tl-select labelText="Entity"
          label="name"
          :options="legalEntityList"
          :reduce="location =>`${location.name}`"
          :value="formData.entityType"
          @change="(val)=>changeFilterVal(val)"
          ></tl-select>
          <tl-select
            labelText="Location"
            label="locationName"
            :options="locationsData"
            :reduce="location =>`${location.locationName}`"
            :value="formData.entityType"
            @change="(val)=>changeFilterLoc(val)"
          ></tl-select>
          <tl-select class="ht-35" labelText="PayGroup"
          :options="entityList"
          :value="formData.entityType"
          @change="(val)=>changeFilterPay(val)"
          ></tl-select>
          <button class="filters-button">More Filters </button>
       </div>
      <div class="search-bar">
        <!-- <tl-search class="half-width" @change="filterData"/> -->
        <tl-search class="half-width" @change="filterData"/>
        <div class="export-section">
          <!-- <img src="@/assets/logout-copy-2.svg" class="logout-copy-2" />
          <button class="export-button">Export</button> -->
        </div>
        <tl-select class="col-2"
          :options="entityList" labelText="Sort By"
          :value="formData.entityType"
          @change="(val)=>formData.payGroup=val">
        </tl-select>
        <div class="side-actions">
          <img src="@/assets/list_view.png" />
          <span class="ver-line" />
          <img src="@/assets/list_view.png" />
          <span class="ver-line" />
          <img src="@/assets/list_view.png" />
        </div>
      </div>
     <data-table
        :columns="employeeTableColumns"
        :tableData="employeeData"
        :checkbox="false"
        :withForm="false"
        :enablerowClick="true"
        @editStart="initEditStart"
        @delete="deleteItem"
        @update="updateItem"
        @selected="selected"
        @deselected="deselected"
        :search="search">
        <template v-slot:rowcontent="slotprops" @click="editComponent(slotprops.value.record)">
           <img class="sm-img" v-if="slotprops.value.column.key=='imgSrc'" :src="slotprops.value.record[slotprops.value.column.key]">
           <p v-if="slotprops.value.column.key!='imgSrc'">{{slotprops.value.record[slotprops.value.column.key]}}</p>
         </template>
      </data-table>

        <footer>
          <toast-message :message="errmsg" v-show="toast" type="error"/>
            <!-- <pop-up-message v-if="showSuccessMsg"
              :message="`Salary Band has been successfully added.`"
              btnText="Back To Salary Bands"
              @back="backfrompopup()"
              /> -->
          <bottom-action-container class="position-fixed">
              <btn-grp slot="end">
               <btn text="Reset" type="secondary" class v-on:click="reset"></btn>
               <btn text="Update Component" type="primary" class v-on:click="update"></btn>
              </btn-grp>
          </bottom-action-container>
          </footer>

  <!-- EMployee Detail Modal -->
  <div class="modal custom-modal" v-if="showCreateModal">
    <div class="modal-content modal-sm">
      <div class="modal-header">
          <h3>Salary Component</h3>
      </div>
      <div class="modal-body">
        <div class="seq-img">
            <span v-for="(srcImg,index) of imgArray" :key="index">
              <img :src="srcImg">
            </span>
        </div>
         <div class="label-text">{{imgArray.length}} Employees Selected</div>
        <div class="twoColumnGrid margintop-20">
          <tl-select
          labelText="Salary Component"
          :options="salaryList"
          :value="formData.salComponent"
          @change="(val)=>formData.salComponent=val"
          ></tl-select>
          <div class="switch">
              <div class="label-text">Component Status</div>
              <input type="checkbox" id="normal" @change="(val)=>formData.status=val.target.checked" v-modal="formData.status">
              <label for="normal"></label>
              <span class="text-green">Allocated</span>
          </div>
          <div class="">
            <div class="label-text">Effective Date</div>
            <date-picker @datevalue="(val)=>formData.effectiveDate=val" :value="formData.effectiveDate"/>
          </div>
        </div>
        <div class="row justify-content-center paddingtop-10p">
            <btn-grp>
              <btn text="Cancel" type="secondary" @click="cancelModal"/>
              <btn text="Save" type="primary" @click="save"/>
            </btn-grp>
        </div>
      </div>
    </div>
  </div>
 </div>
</template>

<script>
import { mapActions,mapGetters } from 'vuex';
export default {
  computed:{
    ...mapGetters({
      orgid: "onboard/organization/orgid"
    }),
    le_id(){
      return "1580822c-764b-11e9-8f9e-2a86e4085a59";
    }
  },
  data() {
    return {
      breadcrumbList:[
              {
                name: "Organisation",
                url: `/dashboard/${this.$route.params.entity_index}/organisation`
              },
              {
                name: "Utilities",
                url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
              },
              {
                name: "Salary Component",
                url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/salarymanagement`
              }
        ],
      showCreateModal: false,
      employeeDetails: {},
      search: "",
      formData: {},
      params: {
       le_id: this.le_id,
      },
      errmsg: "",
      toast: false,
      empListData: [],
      legalEntityList: [],
      salaryList: ["Basic", "HRA", "PF"],
      entityList: ["All", "Bangalore", "Mumbai", "Chennai"],

      employeeTableColumns: [
        {
          label: "",
          key: "imgSrc"
        },
        {
          label: "Code",
          key: "code"
        },
        {
          label: "Name",
          key: "name"
        },
        {
          label: "Department",
          key: "department"
        },
        {
          label: "Email ID",
          key: "email"
        },
        {
          label: "Location",
          key: "location"
        },
        {
          label: "ESS Status",
          key: "essstatus"
        }
      ],
      imgArray: [],
      selectedEmpList:[],
      locationsData:[],
      employeeData: [
        {
          code: "RC1234",
          name: "Roxi",
          department: "IT",
          email: "Roxi@gmail.com",
          location: "Hyderabad",
          essstatus: "Active",
          imgSrc: require("@/assets/user.svg")
        },
        {
          code: "RC1234",
          name: "Roxi",
          department: "IT",
          email: "Roxi@gmail.com",
          location: "Hyderabad",
          essstatus: "Active",
          imgSrc: require("@/assets/user.svg")
        },
        {
          code: "RC1234",
          name: "Roxi",
          department: "IT",
          email: "Roxi@gmail.com",
          location: "Hyderabad",
          essstatus: "Active",
          imgSrc: require("@/assets/user.svg")
        }
      ]
    };
  },
  mounted() {
    //console.log("New component mounted.");
    this.fetchEmplDetails(this.params);
    this.fetchdepartMents();
    this.fetchlocations();
    this.fetchdesignation();
    this.fetchLegalEntities();
  },
  methods: {
    ...mapActions({
      act_fetchCostCenters:'onboard/cost_centres/fetchAll',
      act_departmentList:'onboard/departments/fetchAll',
      act_locationList:'onboard/locations/fetchAll',
      act_designationList:'onboard/designations/fetchAll',
      act_fetchAllEmployees:'dashboard/payroll/employees/fetchAll',
      act_create:'dashboard/payroll/salaryComponent/create',
      act_fetch_Entities: 'onboard/legal_entities/fetchAll'
    }),
    cancelModal() {
      this.showCreateModal = false;
    },
    initEditStart(record) {
      this.imgArray=[];
      this.formData={};
      //console.log("record", record);
      this.employeeDetails = record;
      this.imgArray.push(record.imgSrc);
      this.showCreateModal = true;
    },
    filterData(searchText) {
      this.search = searchText;
    },
    le_id(){
      return "379a50dc-5696-40d8-b7e6-ca2dc0b68d4a";
    },
    changeFilterVal(val){
      this.params.entity=val.id;
      this.fetchEmplDetails(this.params)
    },
    changeFilterLoc(val){
      this.params.loid=val.id
      this.fetchEmplDetails(this.params)
    },
    async performAction() {
       let data = {
          empList: ["10f4785f-277b-4c1b-9300-eb25a3c0b804","454c3590-c68b-49b2-a19e-85f4c18cd4e7"],
          salaryComponent: "454c3590-c68b-49b2-a19e-85f4c18cd4c1",
          status: this.formData.status,
          effectiveDate: this.formData.effectiveDate
        }
      try {
        this.$root._data.isSaving = true;
          await this.act_create({
           ...data
          });
          setTimeout(() => {
            this.$root._data.isSaving = false;
          }, 500);
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err.message;
      }
    },

    save() {
      //console.log("formData", this.formData);
      try {
         this.$validator.validateAll().then(result => {
        if (result) {
          //console.log("perform signup", result);
          this.performAction().then(() => {
          });
        }
      });


      } catch (error) {

      }
      this.showCreateModal = false;
    },
    editComponent(record){
        this.showCreateModal = true;
    },
    cancelModal() {
      this.showCreateModal = false;
      this.formData = {};
    },
     async fetchEmplDetails(queryParams) {
      try {
        let res = await this.act_fetchAllEmployees(queryParams);
        this.employeeListData =  res.rows;
        //console.log('act_fetchAllEmployees',this.employeeListData);
      } catch (err) {
        //console.log(err);
      }
    },


    async fetchdepartMents(){
        try {
          this.departmentData = await this.act_departmentList(this.le_id);
        //console.log('fetchdepartMents',this.departmentData.length);
      } catch (err) {
        //console.log(err);
      }
    },

     async fetchlocations(){
        try {
          this.res = await this.act_locationList(this.le_id);
          this.locationsData = this.res.data;
        //console.log('locationList',this.locationsData.length);
      } catch (err) {
        //console.log(err);
      }
    },
     async fetchdesignation(){
        try {
          this.designationData = await this.act_designationList(this.le_id);
        //console.log('fetchdesignation',this.designationData.length);
      } catch (err) {
        //console.log(err);
      }
    },
     async fetchLegalEntities() {
      try {
        let res = await this.act_fetch_Entities(this.orgid);
       this.legalEntityList = res.data;
        //console.log('fetchAll',res)
      } catch (err) {
        //console.log("intro error", err);
        // this.leData=false
      }
    },
    selected(records){
      this.selectedEmpList = records;
      //console.log('selectedList',records,this.selectedEmpList);

    },
    deselected(records){
      this.selectedEmpList = records;
      //console.log('selectedList',records,this.selectedEmpList);
    },
    refresh(){
      this.formData = {};
    },
    deleteItem(record) {},
    updateItem(record) {},
    reset() {},
    update() {
      this.refresh();
      this.imgArray = [];
      for(let emp of this.selectedEmpList)
      {
        this.imgArray.push(emp.imgSrc);
      }
      this.showCreateModal = true;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/dashboard/_variables.scss"; // Common
@import "@/scss/components/margins.scss";  //margins
@import "@/scss/dashboard/content/_section.scss"; // Content Section
.nav {
  margin-top: 1.7%;
  color: #555555;
  font-size: 11px;
}
.empName label {
  font-size: 16px;
  color: #646464;
  margin-bottom: 4px;
}
.text-green {
  color: #37c6c0;
  padding: 0px 10px;
}
.sm-img {
  width: 35%;
}
.empcode label {
  font-size: 14px;
  color: #878787;
}
[type="radio"]:not(:checked) + label {
  position: relative;
  padding-left: 21px;
  cursor: pointer;
  line-height: 20px;
  display: inline-block;
  color: #646464;
  margin-right: 32px;
}
.main-header {
  color: #6d6d6d;
  margin-top: 37px;
  font-size: 16px;
}
.half-width {
  width: 26.7%;
}
.filters-section {
  display: flex;
  align-items: flex-end;
  margin-top: 30px;
  *:nth-child(n) {
    // margin-right: 10px;
  }
}
.ver-line {
  border-right: solid 1px #30b6bc;
  padding-top: 10px;
}
.emp-img {
  width: auto;
  text-align: center;
}
.component-wrapper {
  padding: 14px;
}
.custom-width-100 {
  width: 100px;
}

.selectdiv {
  select {
    max-width: 200px;
    border-radius: 4px;
    outline: 0;
    font-size: 14px;
    color: #9c9c9c;
    border: 1px solid #dadada;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    /* SVG background image */
    // background: url("@/assets/stroke-1.png");
    background-size: 12px;
    background-position: calc(100% - 10px) center;
    background-repeat: no-repeat;

    option {
      color: #9c9c9c;
      font-size: 12px;
    }
  }
  span {
    color: #b3b3b3;
    font-size: 12px;
  }
}
.seq-img {
  width: 100%;
  display: flex;
  margin: 15px 0px;
  justify-content: center;
  img {
    position: relative;
    width: 100%;
    // align-items: center;
    text-align: center;
  }
}
.filters-button {
  margin-top: 18px;
  width: 95px;
  height: 35px;
  cursor: pointer;
  font-size: 12px;
  /* margin-top: 18px; */
  border-radius: 4px;
  color: #555555;
  border: 1px solid #37c6c0;
}
.search-bar {
  display: flex;
  align-items: center;
}
.essStatus {
  margin: 30px 0px;
  .label-text {
    font-size: 12px;
    font-weight: 500 !important;
    color: #8d8d8d !important;
    height: 15px !important;
  }
}
.export-section {
  margin-left: 39%;
  margin-top: 5px;
  align-items: center;
  display: flex;
  justify-content: flex-end;
}
.export-button {
  width: 60px;
  height: 20px;
  border-radius: 4px;
  font-family: Montserrat;
  font-size: 12px;
  text-align: center;
  border: 1px solid #5d409f;
  color: #5d409f;
  margin-left: 3px;
}
.export-button {
  width: 60px;
  height: 20px;
  border-radius: 4px;
  font-family: Montserrat;
  font-size: 12px;
  text-align: center;
  border: 1px solid #5d409f;
  color: #5d409f;
  margin-left: 3px;
}
.sort-by {
  display: flex;
  margin-left: 1%;

  span {
    margin-right: 10px;
    margin-top: 10px;
    color: #b3b3b3;
    font-size: 12px;
  }
}
.side-actions {
  margin-left: 10px;
  margin-top: 10px;
  img {
    cursor: pointer;
    margin-right: 5px;
    margin-left: 5px;
  }
}

.employee-cards {
  padding: 30px 0 0 10px;
}
/* switch button css */
.switch {
  display: block;
  h3 {
    font-weight: 300;
    padding-bottom: 30px;
  }
  input[type="checkbox"] {
    display: none;
  }
  input[type="checkbox"]:checked + label {
    background-color: #30b6bc;
  }
  input[type="checkbox"]:checked + label:after {
    left: 23px;
  }
  label {
    transition: all 200ms ease-in-out;
    display: inline-block;
    position: relative;
    top: 5px;
    height: 20px;
    width: 40px;
    border-radius: 40px;
    cursor: pointer;
    background-color: #ddd;
    color: transparent;
    &:after {
      transition: all 200ms ease-in-out;
      content: " ";
      position: absolute;
      height: 14px;
      width: 14px;
      border-radius: 50%;
      background-color: white;
      top: 3px;
      left: 3px;
      right: auto;
      box-shadow: 1px 1px 1px gray;
    }
  }
}
</style>
